<template>
  <div id="app">
    <!-- Defining the #page -->
    <div id="page">

      <!-- Navigation trigger -->
      <div id="bars"></div>

      <!-- Main site navigation -->
      <nav id="nav" class="noselect">
        <div class="close js-close-navigation noselect">
          <svg fill="#fff" enable-background="new 0 0 32 32" height="32px" version="1.1" viewBox="0 0 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><polyline fill="none" points="   649,137.999 675,137.999 675,155.999 661,155.999  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></polyline><polyline fill="none" points="   653,155.999 649,155.999 649,141.999  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></polyline><polyline fill="none" points="   661,156 653,162 653,156  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></polyline></g><g><path d="M11.312,12.766c0.194,0.195,0.449,0.292,0.704,0.292c0.255,0,0.51-0.097,0.704-0.292c0.389-0.389,0.389-1.02,0-1.409   L4.755,3.384c-0.389-0.389-1.019-0.389-1.408,0s-0.389,1.02,0,1.409L11.312,12.766z"></path><path d="M17.407,16.048L28.652,4.793c0.389-0.389,0.389-1.02,0-1.409c-0.389-0.389-1.019-0.561-1.408-0.171L15.296,15   c0,0-0.296,0-0.296,0s0,0.345,0,0.345L3.2,27.303c-0.389,0.389-0.315,1.02,0.073,1.409c0.194,0.195,0.486,0.292,0.741,0.292   s0.528-0.097,0.722-0.292L15.99,17.458l11.249,11.255c0.194,0.195,0.452,0.292,0.706,0.292s0.511-0.097,0.705-0.292   c0.389-0.389,0.39-1.02,0.001-1.409L17.407,16.048z"></path></g></svg>
        </div>
        <div class="nav-center">

          <ul>
            <li>
              <a href="#home">
								<span>
									Home
								</span>
              </a>
            </li>
            <li>
              <a href="#about-me">
								<span>
									O mnie
								</span>
              </a>
            </li>
            <li>
              <a href="#head-shots">
								<span>
									Photoshoot
								</span>
              </a>
            </li>
            <li>
              <a href="#demo-reel">
								<span>
									Showreel
								</span>
              </a>
            </li>
            <li>
              <a href="#photo-shoot">
								<span>
									Portfolio
								</span>
              </a>
            </li>
            <li>
              <a href="#warsztaty">
                <span>
                  Warsztaty
                </span>
              </a>
            </li>
            <li>
              <a href="#referencje">
                <span>
                  Referencje
                </span>
              </a>
            </li>
            <li>
              <a href="#audio">
                <span>
                  Audio
                </span>
              </a>
            </li>
            <li>
              <a href="#contact">
								<span>
									Napisz do mnie
								</span>
              </a>
            </li>
          </ul>

          <!-- Links to social networks -->
          <aside id="social-links">
            <a href="https://www.instagram.com/agnieszkahalka.pl/" target="_blank">
              <svg fill="#fff" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1490 1426v-648h-135q20 63 20 131 0 126-64 232.5t-174 168.5-240 62q-197 0-337-135.5t-140-327.5q0-68 20-131h-141v648q0 26 17.5 43.5t43.5 17.5h1069q25 0 43-17.5t18-43.5zm-284-533q0-124-90.5-211.5t-218.5-87.5q-127 0-217.5 87.5t-90.5 211.5 90.5 211.5 217.5 87.5q128 0 218.5-87.5t90.5-211.5zm284-360v-165q0-28-20-48.5t-49-20.5h-174q-29 0-49 20.5t-20 48.5v165q0 29 20 49t49 20h174q29 0 49-20t20-49zm174-208v1142q0 81-58 139t-139 58h-1142q-81 0-139-58t-58-139v-1142q0-81 58-139t139-58h1142q81 0 139 58t58 139z"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/profile.php?id=100000408693797" target="_blank">
              <svg fill="#fff" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"/>
              </svg>
            </a>
            <a href="https://www.youtube.com/channel/UCyqhdtZJeN71_jZwpv3Ty3w" target="_blank">
              <svg fill="#fff" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1099 1244v211q0 67-39 67-23 0-45-22v-301q22-22 45-22 39 0 39 67zm338 1v46h-90v-46q0-68 45-68t45 68zm-966-218h107v-94h-312v94h105v569h100v-569zm288 569h89v-494h-89v378q-30 42-57 42-18 0-21-21-1-3-1-35v-364h-89v391q0 49 8 73 12 37 58 37 48 0 102-61v54zm429-148v-197q0-73-9-99-17-56-71-56-50 0-93 54v-217h-89v663h89v-48q45 55 93 55 54 0 71-55 9-27 9-100zm338-10v-13h-91q0 51-2 61-7 36-40 36-46 0-46-69v-87h179v-103q0-79-27-116-39-51-106-51-68 0-107 51-28 37-28 116v173q0 79 29 116 39 51 108 51 72 0 108-53 18-27 21-54 2-9 2-58zm-608-913v-210q0-69-43-69t-43 69v210q0 70 43 70t43-70zm719 751q0 234-26 350-14 59-58 99t-102 46q-184 21-555 21t-555-21q-58-6-102.5-46t-57.5-99q-26-112-26-350 0-234 26-350 14-59 58-99t103-47q183-20 554-20t555 20q58 7 102.5 47t57.5 99q26 112 26 350zm-998-1276h102l-121 399v271h-100v-271q-14-74-61-212-37-103-65-187h106l71 263zm370 333v175q0 81-28 118-37 51-106 51-67 0-105-51-28-38-28-118v-175q0-80 28-117 38-51 105-51 69 0 106 51 28 37 28 117zm335-162v499h-91v-55q-53 62-103 62-46 0-59-37-8-24-8-75v-394h91v367q0 33 1 35 3 22 21 22 27 0 57-43v-381h91z"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/wypisz.wymaluj.my/" target="_blank">
              <svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1703 478q40 57 18 129l-275 906q-19 64-76.5 107.5t-122.5 43.5h-923q-77 0-148.5-53.5t-99.5-131.5q-24-67-2-127 0-4 3-27t4-37q1-8-3-21.5t-3-19.5q2-11 8-21t16.5-23.5 16.5-23.5q23-38 45-91.5t30-91.5q3-10 .5-30t-.5-28q3-11 17-28t17-23q21-36 42-92t25-90q1-9-2.5-32t.5-28q4-13 22-30.5t22-22.5q19-26 42.5-84.5t27.5-96.5q1-8-3-25.5t-2-26.5q2-8 9-18t18-23 17-21q8-12 16.5-30.5t15-35 16-36 19.5-32 26.5-23.5 36-11.5 47.5 5.5l-1 3q38-9 51-9h761q74 0 114 56t18 130l-274 906q-36 119-71.5 153.5t-128.5 34.5h-869q-27 0-38 15-11 16-1 43 24 70 144 70h923q29 0 56-15.5t35-41.5l300-987q7-22 5-57 38 15 59 43zm-1064 2q-4 13 2 22.5t20 9.5h608q13 0 25.5-9.5t16.5-22.5l21-64q4-13-2-22.5t-20-9.5h-608q-13 0-25.5 9.5t-16.5 22.5zm-83 256q-4 13 2 22.5t20 9.5h608q13 0 25.5-9.5t16.5-22.5l21-64q4-13-2-22.5t-20-9.5h-608q-13 0-25.5 9.5t-16.5 22.5z"
                  fill="#fff"/>
              </svg>
            </a>

            <!-- You can find more SVG icons here: https://github.com/encharm/Font-Awesome-SVG-PNG/tree/master/white/svg -->
            <!-- Here are some major icons you can use:
                        <a href="https://www.linkedin.com/" target="_blank">
                            <svg fill="#fff" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M477 625v991h-330v-991h330zm21-306q1 73-50.5 122t-135.5 49h-2q-82 0-132-49t-50-122q0-74 51.5-122.5t134.5-48.5 133 48.5 51 122.5zm1166 729v568h-329v-530q0-105-40.5-164.5t-126.5-59.5q-63 0-105.5 34.5t-63.5 85.5q-11 30-11 81v553h-329q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5 114.5-15.5q171 0 275 113.5t104 332.5z" /></svg>
                        </a>
                        <a href="https://plus.google.com/" target="_blank">
                            <svg fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="2304px" height="1466px" viewBox="-256 163 2304 1466" enable-background="new -256 163 2304 1466" xml:space="preserve"><path d="M1181,913c0,138.667-29,262.167-87,370.5s-140.667,193-248,254S615.667,1629,477,1629c-99.333,0-194.333-19.333-285-58s-168.667-90.667-234-156s-117.333-143.333-156-234s-58-185.667-58-285s19.333-194.333,58-285s90.667-168.667,156-234c65.333-65.333,143.333-117.333,234-156s185.667-58,285-58c190.667,0,354.333,64,491,192L769,546c-78-75.333-175.333-113-292-113c-82,0-157.833,20.667-227.5,62C179.833,536.333,124.667,592.5,84,663.5S23,812,23,896s20.333,161.5,61,232.5s95.833,127.167,165.5,168.5c69.667,41.333,145.5,62,227.5,62c55.333,0,106.167-7.667,152.5-23s84.5-34.5,114.5-57.5s56.167-49.167,78.5-78.5s38.667-57,49-83s17.5-50.667,21.5-74H477V791h692C1177,833,1181,873.667,1181,913z M2048,791v210h-209v209h-210v-209h-209V791h209V582h210v209H2048z"/></svg>
                        </a>
                        <a href="https://www.youtube.com/" target="_blank">
                            <svg fill="#fff" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1099 1244v211q0 67-39 67-23 0-45-22v-301q22-22 45-22 39 0 39 67zm338 1v46h-90v-46q0-68 45-68t45 68zm-966-218h107v-94h-312v94h105v569h100v-569zm288 569h89v-494h-89v378q-30 42-57 42-18 0-21-21-1-3-1-35v-364h-89v391q0 49 8 73 12 37 58 37 48 0 102-61v54zm429-148v-197q0-73-9-99-17-56-71-56-50 0-93 54v-217h-89v663h89v-48q45 55 93 55 54 0 71-55 9-27 9-100zm338-10v-13h-91q0 51-2 61-7 36-40 36-46 0-46-69v-87h179v-103q0-79-27-116-39-51-106-51-68 0-107 51-28 37-28 116v173q0 79 29 116 39 51 108 51 72 0 108-53 18-27 21-54 2-9 2-58zm-608-913v-210q0-69-43-69t-43 69v210q0 70 43 70t43-70zm719 751q0 234-26 350-14 59-58 99t-102 46q-184 21-555 21t-555-21q-58-6-102.5-46t-57.5-99q-26-112-26-350 0-234 26-350 14-59 58-99t103-47q183-20 554-20t555 20q58 7 102.5 47t57.5 99q26 112 26 350zm-998-1276h102l-121 399v271h-100v-271q-14-74-61-212-37-103-65-187h106l71 263zm370 333v175q0 81-28 118-37 51-106 51-67 0-105-51-28-38-28-118v-175q0-80 28-117 38-51 105-51 69 0 106 51 28 37 28 117zm335-162v499h-91v-55q-53 62-103 62-46 0-59-37-8-24-8-75v-394h91v367q0 33 1 35 3 22 21 22 27 0 57-43v-381h91z" /></svg>
                        </a>
                        <a href="https://www.pinterest.com/" target="_blank">
                            <svg fill="#fff" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1664 896q0 209-103 385.5t-279.5 279.5-385.5 103q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214t-172.5-163-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5-21.5 134q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5t273.5-108.5q151 0 235.5 82t84.5 213q0 170-68.5 289t-175.5 119q-61 0-98-43.5t-23-104.5q8-35 26.5-93.5t30-103 11.5-75.5q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281t-127-423q0-209 103-385.5t279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" /></svg>
                        </a>
                        <a href="https://www.tumblr.com/" target="_blank">
                            <svg fill="#fff" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1328 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26t-142.5-74-95-106-55.5-120-16.5-118v-544h-168v-215q72-26 129-69.5t91-90 58-102 34-99 15-88.5q1-5 4.5-8.5t7.5-3.5h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z" /></svg>
                        </a>
                        <a href="https://vimeo.com/" target="_blank">
                            <svg fill="#fff" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1709 518q-10 236-332 651-333 431-562 431-142 0-240-263-44-160-132-482-72-262-157-262-18 0-127 76l-77-98q24-21 108-96.5t130-115.5q156-138 241-146 95-9 153 55.5t81 203.5q44 287 66 373 55 249 120 249 51 0 154-161 101-161 109-246 13-139-109-139-57 0-121 26 120-393 459-382 251 8 236 326z" /></svg>
                        </a>
                        -->
          </aside>

        </div>

      </nav>

      <!-- Website "Header" -->
      <header id="home" class="header">

        <div id="background" style="background-image: url(/static/images/szare-tlo.jpg)"></div>

        <div class="header-center noselect">
          <h1>
            Agnieszka Hałka
          </h1>
          <h3>
            aktorka scen muzycznych, pedagog
          </h3>
        </div>

        <!-- Scroll down arrow -->
        <div id="arrow" class="sr-group-1">
          <svg fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="24px" viewBox="0 0 20 24" enable-background="new 0 0 20 24" xml:space="preserve"><g><path d="M9.293,23.707C9.484,23.898,9.741,24,10,24c0.129,0,0.259-0.023,0.383-0.076C10.756,23.77,11,23.404,11,23V1c0-0.552-0.448-1-1-1S9,0.448,9,1v19.586l-7.293-7.293c-0.391-0.391-1.023-0.391-1.414,0c-0.391,0.391-0.391,1.023,0,1.414L9.293,23.707z"/><path d="M14,20c0.256,0,0.512-0.098,0.707-0.293l5-5c0.391-0.391,0.391-1.023,0-1.414c-0.391-0.39-1.023-0.391-1.414,0.001l-5,5c-0.391,0.392-0.391,1.022,0,1.414C13.489,19.902,13.745,20,14,20z"/></g></svg>
        </div>

      </header>

      <!-- "About me" section -->
      <section id="about-me" class="section section-about">
        <div>
          <figure class="picture sr" style="background-image: url(/static/images/portret-2020.jpg)"></figure>
          <div>
            <h2>
              O mnie
            </h2>


            <p>Agnieszka Hałka (ur. 06.września 1989r. w Głogowie, zam. w Warszawie) <br>
              Z wykształcenia jestem Magistrem Pedagogiki oraz Aktorką Scen Muzycznych. <br>
              Ukończyłam również Ist. PSM w klasie fletu poprzecznego oraz Studio Wokalne. <br>
            </p>

            <p>Obecnie pracuję w Teatrze Katarynka i jestem instruktorką warsztatów teatralnych w grupach dziecięcych i młodzieżowych.
              <br>
              W ramach pracy warsztatowej wyreżyserowałam kilka pokazów teatralnych. <br>
              
            </p>

            <p>Dotychczas współpracowałam m.in. ze Sceną Kamienica we Wrocławiu oraz Teatrem Neon. Pracowałam w międzynarodowym zespole animatorów jako wokalistka oraz tancerka podczas kontraktu w Grecji.
              Uczestniczyłam w Krajowym Festiwalu Piosenki Polskiej w Opolu.<br>
               Mam na swoim koncie role w krótkometrażowych filmach niezależnych oraz komercyjnych produkcjach filmowych i telewizyjnych.
               <br>
              
            </p>
            <p>
              Piszę własne teksty <a
              class="social-link" href="https://www.facebook.com/wypisz.wymaluj.my/" target="_blank">
              <svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1703 478q40 57 18 129l-275 906q-19 64-76.5 107.5t-122.5 43.5h-923q-77 0-148.5-53.5t-99.5-131.5q-24-67-2-127 0-4 3-27t4-37q1-8-3-21.5t-3-19.5q2-11 8-21t16.5-23.5 16.5-23.5q23-38 45-91.5t30-91.5q3-10 .5-30t-.5-28q3-11 17-28t17-23q21-36 42-92t25-90q1-9-2.5-32t.5-28q4-13 22-30.5t22-22.5q19-26 42.5-84.5t27.5-96.5q1-8-3-25.5t-2-26.5q2-8 9-18t18-23 17-21q8-12 16.5-30.5t15-35 16-36 19.5-32 26.5-23.5 36-11.5 47.5 5.5l-1 3q38-9 51-9h761q74 0 114 56t18 130l-274 906q-36 119-71.5 153.5t-128.5 34.5h-869q-27 0-38 15-11 16-1 43 24 70 144 70h923q29 0 56-15.5t35-41.5l300-987q7-22 5-57 38 15 59 43zm-1064 2q-4 13 2 22.5t20 9.5h608q13 0 25.5-9.5t16.5-22.5l21-64q4-13-2-22.5t-20-9.5h-608q-13 0-25.5 9.5t-16.5 22.5zm-83 256q-4 13 2 22.5t20 9.5h608q13 0 25.5-9.5t16.5-22.5l21-64q4-13-2-22.5t-20-9.5h-608q-13 0-25.5 9.5t-16.5 22.5z"
                  fill="#fff"/>
              </svg>
            </a> i śpiewam. W wolnym czasie rozwijam swoje umiejętności lektorskie i nagrywam m.in. wiersze dla dzieci. 
            </p>
            
          </div>
          <a class="button noselect" target="_blank" download
             href="/static/files/AgnieszkaHalkaCVART2020.pdf">
            Pobierz CV
          </a>
        </div>
      </section>

      <!-- "Head shots" section -->
      <section id="head-shots" class="section section-grid">
        <h2 class="unvisible">
          Head shots
        </h2>
        <div data-columns class="grid grid-headshots">
          <figure class="figure figure-100 sr-group-3"
                  style="background-image: url('/static/images/headshots/headshot1.jpg')"></figure>
          <figure class="figure figure-100 sr-group-3"
                  style="background-image: url('/static/images/headshots/headshot2.jpg')"></figure>
          <figure class="figure figure-100 sr-group-3"
                  style="background-image: url('/static/images/headshots/headshot3.jpg')"></figure>
          <figure class="figure figure-100 sr-group-3"
                  style="background-image: url('/static/images/headshots/headshot4.jpg')"></figure>
        </div>
      </section>

      <!-- "Demo reel" section -->
      <!-- You must add a video poster (JPG type). It must be in the same
            place as video and must have a same name, e.g.: video/video.jpg -->
      <section id="demo-reel" class="section section-video" data-video="/static/video/showreel2016-short.mp4">
        <div>
          <h3>
            Showreel 2016
          </h3>
          <button class="theme-button js-open-video noselect">
            Zobacz video
          </button>
        </div>
      </section>

      <!--<section id="head-shots" class="section section-grid">-->
        <!--<h2 class="unvisible">-->
          <!--Head shots-->
        <!--</h2>-->
        <!--<div data-columns class="grid grid-2">-->

          <!--<figure class="figure figure-66 sr-group-4"-->
                            <!--&gt;-->
            <!--<vimeo-player ref="player" :video-id="videoIdFilmVimeo"/>-->
                    <!--</figure>-->

            <!--<youtube video-id="jtjFYW0zK4E"/>-->
          <!--</div>-->

      <!--</section>-->

      <section id="photo-shoot" class="section section-grid">
        <h2>
          Teatr
        </h2>
        <!--<youtube :video-id="videoId" :player-vars="{ autoplay: 1 }" @playing="playing"></youtube>-->
        <div data-columns class="grid grid-2">

          <figure v-on:click="openLightbox" class="figure figure-66 sr-group-4"
                  :style="getBackgroundImageStyle(images)">
            <img v-for="item in images" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden src="">
            <p>Damy i Huzary (2017) - Teatr Sztampa</p>
          </figure>

          <figure v-on:click="openLightbox" class="figure figure-66 sr-group-4"
                  :style="getBackgroundImageStyle(gaska)">
            <img v-for="item in gaska" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Gąska (2016) - Teatr Sztampa </p>
          </figure>

          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(oczy)">
            <img v-for="item in oczy" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Oczy Paść Będę Cieniem (2016)</p>
          </figure>

          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(moralnosc)">
            <img v-for="item in moralnosc" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Moralność Pani Dulskiej (2015) - Teatr Sztampa</p>
          </figure>

          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(capitol)">
            <img v-for="item in capitol" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Rat Pack, czyli Sinatra z kolegami (2014) - Teatr Muzyczny Capitol</p>
          </figure>

          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(samsara)">
            <img v-for="item in samsara" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Krąg Samsary (2014) - Teatr Sztampa</p>
          </figure>

          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(mrozek)">
            <img v-for="item in mrozek" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Mrożka. Projekta rozmaite (2012) - Teatr Sztampa</p>
          </figure>

          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(grecja)">
            <img v-for="item in grecja" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Life is a Cabaret (2015) - Grecja</p>
          </figure>

        </div>
        <div data-columns class="grid grid-full">
          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(totu)">
            <img v-for="item in totu" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Koncert Sylwestrowy w Klubie ToTu 2017/2018</p>
          </figure>
        </div>
      </section>

      <!-- "Photo shoot film" section -->
      <section id="photo-shoot-film" class="section section-grid">
        <h2>
          Film
        </h2>
        <div data-columns class="grid grid-2">
          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(sabat)">
            <img v-for="item in sabat" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Sabat (2017) reż. M. Matuszewski & K. Poźniak</p>
          </figure>

          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(poslizg)">
            <img v-for="item in poslizg" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Poślizg (2016) reż. Rafał Makovsky Kaczmarek</p>
          </figure>

        </div>
      </section>

      <!-- "Photo shoot" section -->
      <section id="photo-shoot-modeling" class="section section-grid">
        <h2>
          Fotomodeling
        </h2>
        <div data-columns class="grid grid-2">


          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(brzydkadobrzeoswietlona)">
            <img v-for="item in brzydkadobrzeoswietlona" v-img="{group:item.group, src:item.src}" :alt="item.alt"
                 hidden>
            <p>Sesja (2017)Brzydka, ale dobrze oświetlona</p>
          </figure>

          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(wgolfie)">
            <img v-for="item in wgolfie" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Sesja (2017) NoName</p>
          </figure>

          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(pokusa)">
            <img v-for="item in pokusa" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Sesja (2017) Pokusa</p>
          </figure>

          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(glamour)">
            <img v-for="item in glamour" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Sesja (2016) Glamour</p>
          </figure>

          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(glamourpiotr)">
            <img v-for="item in glamourpiotr" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Sesja (2014) Glamour</p>
          </figure>

          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(audrey)">
            <img v-for="item in audrey" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Sesja (2015) Audrey Project</p>
          </figure>

        </div>
        <div data-columns class="grid grid-full">
          <figure v-on:click="openLightbox" class="figure figure-66"
                  :style="getBackgroundImageStyle(womaninred)">
            <img v-for="item in womaninred" v-img="{group:item.group, src:item.src}" :alt="item.alt" hidden>
            <p>Sesja (2015) Woman in red</p>
          </figure>
        </div>
      </section>

      <section id="warsztaty" class="section section-warsztaty">

        <h2>
          Warsztaty
        </h2>


        <figure v-on:click="openLightbox" class="figure flleft"
                :style="getBackgroundImageStyle(warsztatynew,0)">
          <img v-img="{group:warsztatynew, src:warsztatynew[0].src}" :alt="warsztatynew[0].alt" hidden>
        </figure>
        <p>
          W 2013 roku ukończyłam studia wyższe z Resocjalizacji oraz Pedagogiki Opiekuńczej.
          Od tego czasu zdobywałam doświadczenie w pracy z dziećmi i młodzieżą, również z rodzin dysfunkcyjnych,
          pracując w różnego rodzaju placówkach opiekuńczo-wychowawczych.
        </p>
        <figure v-on:click="openLightbox" class="figure flright"
                :style="getBackgroundImageStyle(warsztatynew,1)">
          <img v-img="{group:warsztatynew, src:warsztatynew[1].src}" :alt="warsztatynew[1].alt" hidden>
        </figure>
        <p>
          Od początku wiedziałam, że pragnę połączyć teatr z pracą wśród młodszych pokoleń, kształtując tym samym ich
          wyobraźnię i charakter.
        </p>

        <figure v-on:click="openLightbox" class="figure flleft"
                :style="getBackgroundImageStyle(warsztatynew,2)">
          <img v-img="{group:warsztatynew, src:warsztatynew[2].src}" :alt="warsztatynew[2].alt" hidden>
        </figure>
        <p>
          Od 2016 roku prowadzę warsztaty teatralne dla dzieci i młodzieży, współpracując z biurem podróży
          www.jaworzyna.com.pl. <br>
          Jako instruktor teatralny pracowałam również dla firmy www.camport.pl oraz www.wakacjeartystyczne.pl.
          (referencje dostępne są w zakładce poniżej).
        </p>

        <figure v-on:click="openLightbox" class="figure flright"
                :style="getBackgroundImageStyle(warsztatynew,3)">
          <img v-img="{group:warsztatynew, src:warsztatynew[3].src}" :alt="warsztatynew[3].alt" hidden>
        </figure>
        <p>
          W swoich zajęciach wykorzystuję techniki z pedagogiki zabawy, przeplatając je z teoretycznymi podstawami z
          zakresu wiedzy o teatrze. Tematykę zajęć dostosowuję każdorazowo do grupy pod wzgledem wieku, rodzaju i ilości
          uczestników. <br>
          Warsztaty, które prowadzę mają charakter przekrojowy. Słuchacze warsztatów mają możliwość poznać dzień pracy
          aktora poprzez działania praktyczne. Uczą się prawidłowego oddechu, emisji głosu oraz impostacji. </p>
        <figure v-on:click="openLightbox" class="figure flleft"
                :style="getBackgroundImageStyle(warsztatynew,4)">
          <img v-img="{group:warsztatynew, src:warsztatynew[4].src}" :alt="warsztatynew[4].alt" hidden>
        </figure>
        <p>
          W zależności od grupy i tematyki zajęć wprowadzane są także elementy improwizacji scenicznej. Uczestnicy
          poznają techniki teatralne, następnie sami tworzą etiudy bądź pokazy sceniczne pod moim kierunkiem, które są w
          zupełności autorskie, począwszy od stworzenia scenariusza, przez podział ról, po reżyserię. <br>
          Wszystko to dzieje się w oparciu o metody pedagogiczne nie zapominając o dobrej zabawie.
        </p>

      </section>

      <!-- "Referencje" section -->
      <section id="referencje" class="section section-referencje">
        <h2>
          Referencje
        </h2>
        <div data-columns class="grid grid-full">
          <figure v-on:click="openLightbox" class="figure figure-10 sr-group-3">
                  <!--:style="getBackgroundImageStyle(referencje, 0)">-->
            <img v-for="item in referencje" v-img="{group:item.group, src:item.src}" :alt="item.alt" :src="item.src" >
          </figure>
        </div>


      </section>

      <!-- "Audio" section -->
      <section id="audio" class="section section-audio">
        <h2>Audio</h2>
          <aplayer
            :music=musicList[0]
            :list=musicList
            :theme=musicTheme
          />
      </section>

      <!-- "Contacts me" section -->
      <section id="contact" class="section section-contact">
        <h2>Napisz do mnie</h2>
        
        <h4>
          a.halka89@gmail.com
        </h4>
      </section>

      <!-- Footer -->
      <footer>
        Copyright 2019 - agnieszkahalka.pl
      </footer>

      <!-- Closing the #page -->
    </div>

    <!-- Video modal window -->
    <aside id="fullscreen-video" data-video="/static/video/showreel2016-full.mp4">
      <div>
        <div class="close js-close-video noselect">
          <svg fill="#fff" enable-background="new 0 0 32 32" height="32px" version="1.1" viewBox="0 0 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><polyline fill="none" points="   649,137.999 675,137.999 675,155.999 661,155.999  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><polyline fill="none" points="   653,155.999 649,155.999 649,141.999  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><polyline fill="none" points="   661,156 653,162 653,156  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/></g><g><path d="M11.312,12.766c0.194,0.195,0.449,0.292,0.704,0.292c0.255,0,0.51-0.097,0.704-0.292c0.389-0.389,0.389-1.02,0-1.409   L4.755,3.384c-0.389-0.389-1.019-0.389-1.408,0s-0.389,1.02,0,1.409L11.312,12.766z"/><path d="M17.407,16.048L28.652,4.793c0.389-0.389,0.389-1.02,0-1.409c-0.389-0.389-1.019-0.561-1.408-0.171L15.296,15   c0,0-0.296,0-0.296,0s0,0.345,0,0.345L3.2,27.303c-0.389,0.389-0.315,1.02,0.073,1.409c0.194,0.195,0.486,0.292,0.741,0.292   s0.528-0.097,0.722-0.292L15.99,17.458l11.249,11.255c0.194,0.195,0.452,0.292,0.706,0.292s0.511-0.097,0.705-0.292   c0.389-0.389,0.39-1.02,0.001-1.409L17.407,16.048z"/></g></svg>
        </div>
      </div>
    </aside>

    <!-- Preloader -->
    <div id="preload">
      <span>Loading <span class="ellipsis">.</span><span class="ellipsis">.</span><span class="ellipsis">.</span></span>
    </div>

    <!-- Hidden element, helper for navigation -->
    <div id="offset-element"></div>

    <!-- Settings (lists all themes) -->
    <!--<?php include 'includes/settings.php'; ?>-->

    <!--<script type="text/javascript" src="assets/js/plugins.min.js"></script>-->
    <!--<script type="text/javascript" src="assets/js/app.js"></script>-->

    <!--<router-view/>-->
  </div>
</template>

<script>

import Aplayer from 'vue-aplayer';
/* eslint-disable */
  export default {
    name: 'App',
    components: {
        Aplayer
      },
    data() {
      return {
        videoIdGaska: 'AA2NopLqwmI',
        videoIdFilmVimeo: '341984494',
        playerVars: {
          autoplay: 1
        },
        isRevealed: false,
        button: {
          text: "zobacz więcej"
        },
        images: [
          {
            src: '/static/images/damyihuzary/Dami-i-Huzary-w-Gminnym-Osrodku-Kultury-w-Pawlowicach.jpg',
            alt: 'Damy i Huzary w Gminnym Ośrodku Kultury w Pawłowicach',
            group: "images"
          },
          {
            src: '/static/images/damyihuzary/fot.-Anna-Pizon.jpg',
            alt: 'fot. Anna Pizoń',
            group: "images"
          },
          {
            src: '/static/images/damyihuzary/DamyiHuzary(2017).jpg',
            alt: 'Damy i Huzary w Gminnym Ośrodku Kultury w Pawłowicach',
            group: "images"
          },
        ],

        gaska: [
          {
            src: '/static/images/gaska/Gaska(2016)-Teatr-Sztampa-Justyna-Chwala.jpg',
            alt: 'Justyna Chwała',
            group: 'gaska'
          },
          {
            src: '/static/images/gaska/fot.-Justyna-Chwala.jpg',
            alt: 'fot. Justyna Chwała',
            group: 'gaska'
          },
          {
            src: '/static/images/gaska/Gaska-Teatr-Sztampa-fot.-Angelika-Rogozinska.jpg',
            alt: 'fot. Angelika Rogozinska',
            group: 'gaska'
          },
          {
            src: '/static/images/gaska/Justyna-Chwala.jpg',
            alt: 'fot. Justyna Chwała',
            group: 'gaska'
          },
          {
            src: '/static/images/gaska/fot.-Justyna-Chwala-(2).jpg',
            alt: 'fot. Justyna Chwała',
            group: 'gaska'
          },
          {
            src: '/static/images/gaska/Justyna-Chwala2.jpg',
            alt: 'fot. Justyna Chwała',
            group: 'gaska'
          },
          {
            src: '/static/images/gaska/Justyna-Chwala1.jpg',
            alt: 'fot. Justyna Chwała',
            group: 'gaska'
          }
        ],
        capitol: [
          {
            src: '/static/images/capitol/RatPack,-czyli-Frank-Sinatra-z-kolegami(2014)-Teatr-Muzyczny-Capitol.jpg',
            alt: 'Rat Pack, czyli Sinatra z kolegami(2014) - Teatr Muzyczny Capitol',
            group: 'capitol'
          },
        ],
        grecja: [
          {
            src: '/static/images/grecja/Life-is-a-Cabaret-(2015)..jpg',
            alt: 'Life is a Cabaret (2015) - Grecja',
            group: 'grecja'
          },
          {
            src: '/static/images/grecja/Life-is-a-Cabaret-(2015).jpg',
            alt: 'Life is a Cabaret (2015) - Grecja',
            group: 'grecja'
          },
          {
            src: '/static/images/grecja/WidowiskoVariete-Grecja(2015).jpg',
            alt: 'Life is a Cabaret (2015) - Grecja',
            group: 'grecja'
          },
          {
            src: '/static/images/grecja/WidowiskoGrease-Grecja(2015).jpg',
            alt: 'Grease (2015) - Grecja',
            group: 'grecja'
          }
        ],
        oczy: [{
          src: '/static/images/oczy/OczyPascBedeCieniem(2016)-fot.-greg-noo-wak.jpg',
          alt: 'fot. Greg Noo-Wak',
          group: 'oczy'
        },
          {
            src: '/static/images/oczy/studium(25).jpg',
            alt: 'fot. Greg Noo-Wak',
            group: 'oczy'
          },
          {
            src: '/static/images/oczy/OczyPascBedeCieniemDYPLOM2016.jpg',
            alt: 'fot. Greg Noo-Wak',
            group: 'oczy'
          },
          {
            src: '/static/images/oczy/Otello.jpg',
            alt: 'fot. Greg Noo-Wak',
            group: 'oczy'
          }],
        moralnosc: [{
          src: '/static/images/moralnosc/MoralnoscPaniDulskiej(2015).jpg',
          alt: 'fot. Angelika Rogozińska',
          group: 'moralnosc'
        },
          {
            src: '/static/images/moralnosc/10153187_722705204456754_3113752726237702820_n.jpg',
            alt: 'fot. Angelika Rogozińska',
            group: 'moralnosc'
          },
          {
            src: '/static/images/moralnosc/10154094_722705067790101_4617211092130071608_n.jpg',
            alt: 'fot. Angelika Rogozińska',
            group: 'moralnosc'
          },
          {
            src: '/static/images/moralnosc/fot.AngelikaRogozinska.jpg',
            alt: 'fot. Angelika Rogozińska',
            group: 'moralnosc'
          }],
        samsara: [{
          src: '/static/images/samsara/fot.AngelikaRogozinska1.jpg',
          alt: 'fot. Angelika Rogozińska',
          group: 'samsara'
        },
          {
            src: '/static/images/samsara/Krag-Samsary-fot.-Justyna-Chwala.jpg',
            alt: 'fot. Justyna Chwała',
            group: 'samsara'
          },
          {
            src: '/static/images/samsara/Krag-Samsary(2014)-Teatr-Sztampa-(fot.-Angelika-Rogozinska).jpg',
            alt: 'fot. Angelika Rogozińska',
            group: 'samsara'
          },
          {
            src: '/static/images/samsara/fot.-Angelika-Rogozinska.jpg',
            alt: 'fot. Angelika Rogozińska',
            group: 'samsara'
          }],
        mrozek: [{
          src: '/static/images/mrozek/6675_10151176508524649_1500709984_n.jpg',
          alt: 'fot. Ewa Szymaszczyk',
          group: 'mrozek'
        },
          {
            src: '/static/images/mrozek/228918_10151176485984649_474585780_n.jpg',
            alt: 'fot. Ewa Szymaszczyk',
            group: 'mrozek'
          },
          {
            src: '/static/images/mrozek/fot.-Ewa-Szymaszczyk.jpg',
            alt: 'fot. Ewa Szymaszczyk',
            group: 'mrozek'
          }],
        sabat: [{
          src: '/static/images/sabat/Kadr-z-filmu-Sabat(2017)-rez.-K.Pawlak&M.Matuszewski.jpg',
          alt: 'reż. K.Pawlak & M.Matuszewski',
          group: 'sabat'
        },
          {
            src: '/static/images/sabat/Kadr-z-Sabat.jpg',
            alt: 'reż. K.Pawlak & M.Matuszewski',
            group: 'sabat'
          },
          {
            src: '/static/images/sabat/Kadr-z-filmu-Sabat-2017)-rez,-K.Pawlak&M.Matuszewski02.jpg',
            alt: 'reż. K.Pawlak & M.Matuszewski',
            group: 'sabat'
          },
          {
            src: '/static/images/sabat/Kadr-z-filmu-Sabat.jpg',
            alt: 'reż. K.Pawlak & M.Matuszewski',
            group: 'sabat'
          }],
        brzydkadobrzeoswietlona: [{
          src: '/static/images/brzydkadobrzeoswietlona/Pawlak01.jpg',
          alt: 'reż. K.Pawlak & M.Matuszewski',
          group: 'brzydkadobrzeoswietlona'
        },
          {
            src: '/static/images/brzydkadobrzeoswietlona/Pawlak03.jpg',
            alt: 'fot. K. Pawlak',
            group: 'brzydkadobrzeoswietlona'
          },
          {
            src: '/static/images/brzydkadobrzeoswietlona/Pawlak02.jpg',
            alt: 'fot. K. Pawlak',
            group: 'brzydkadobrzeoswietlona'
          },
          {
            src: '/static/images/brzydkadobrzeoswietlona/Pawlak05.jpg',
            alt: 'fot. K. Pawlak',
            group: 'brzydkadobrzeoswietlona'
          },
          {
            src: '/static/images/brzydkadobrzeoswietlona/Pawlak04.jpg',
            alt: 'fot. K. Pawlak',
            group: 'brzydkadobrzeoswietlona'
          },
          {
            src: '/static/images/brzydkadobrzeoswietlona/Sesja-Brzydka-ale-dobrze-oswietlona-2017)-fot.-Kamil-Pawlak.jpg',
            alt: 'fot. K. Pawlak',
            group: 'brzydkadobrzeoswietlona'
          }],
        totu: [{
          src: '/static/images/totu/Koncert-Sylwestrowy-2017)-w-Klubie-ToTu.jpg',
          alt: 'Koncert Sylwestrowy w Klubie ToTu 2017/2018',
          group: 'totu'
        },
          {
            src: '/static/images/totu/Koncert-Sylwwestrowy-w-Totu.jpg',
            alt: 'Koncert Sylwestrowy w Klubie ToTu 2017/2018',
            group: 'totu'
          }],
        poslizg: [{
          src: '/static/images/poslizg/1.jpeg',
          alt: 'reż. Rafał Makovsky Kaczmarek',
          group: 'poslizg'
        },
          {
            src: '/static/images/poslizg/Poslizg-(2016)-rez.-Rafał Makowski.jpeg',
            alt: 'reż. Rafał Makovsky Kaczmarek',
            group: 'poslizg'
          },
          {
            src: '/static/images/poslizg/2.jpeg',
            alt: 'reż. Rafał Makovsky Kaczmarek',
            group: 'poslizg'
          },
          {
            src: '/static/images/poslizg/3.jpeg',
            alt: 'reż. Rafał Makovsky Kaczmarek',
            group: 'poslizg'
          }],
        wgolfie: [{
          src: '/static/images/wgolfie/fot.-Kamil-Pawlak01.jpg',
          alt: 'fot. Kamil Pawlak',
          group: 'wgolfie'
        },
          {
            src: '/static/images/wgolfie/fot.-Kamil-Pawlak.jpg',
            alt: 'fot. Kamil Pawlak',
            group: 'wgolfie'
          },
          {
            src: '/static/images/wgolfie/Kamil-Pawlak.jpg',
            alt: 'fot. Kamil Pawlak',
            group: 'wgolfie'
          }],
        pokusa: [{
          src: '/static/images/pokusa/Pokusa(2017.02).jpg',
          alt: 'fot. Kamil Pawlak',
          group: 'pokusa'
        },
          {
            src: '/static/images/pokusa/Pokusa(2017.03).jpg',
            alt: 'fot. Kamil Pawlak',
            group: 'pokusa'
          },
          {
            src: '/static/images/pokusa/Pokusa(2017.01).jpg',
            alt: 'fot. Kamil Pawlak',
            group: 'pokusa'
          }],
        glamour: [{
          src: '/static/images/glamour/Glamour(2016.04).jpg',
          alt: 'fot. Karolina Konopska',
          group: 'glamour'
        },
          {
            src: '/static/images/glamour/Glamour(2016.02).jpg',
            alt: 'fot. Karolina Konopska',
            group: 'glamour'
          },
          {
            src: '/static/images/glamour/Glamour(2016.03).jpg',
            alt: 'fot. Karolina Konopska',
            group: 'glamour'
          },
          {
            src: '/static/images/glamour/Sesja-Glamour(2016)---fot.-Karolina-Konopska.jpg',
            alt: 'fot. Karolina Konopska',
            group: 'glamour'
          }],
        glamourpiotr: [{
          src: '/static/images/glamourpiotr/Glamour(2014.03).jpg',
          alt: 'fot. Piotr Gonia',
          group: 'glamourpiotr'
        },
          {
            src: '/static/images/glamourpiotr/Glamour(2014.02).jpg',
            alt: 'fot. Piotr Gonia',
            group: 'glamourpiotr'
          },
          {
            src: '/static/images/glamourpiotr/Glamour(2014.05).jpg',
            alt: 'fot. Piotr Gonia',
            group: 'glamourpiotr'
          },
          {
            src: '/static/images/glamourpiotr/Glamour(2014.08).jpg',
            alt: 'fot. Piotr Gonia',
            group: 'glamourpiotr'
          },
          {
            src: '/static/images/glamourpiotr/Sesja-Glamour(2014)---fot.-Piotr-Gonia.jpg',
            alt: 'fot. Piotr Gonia',
            group: 'glamourpiotr'
          },
          {
            src: '/static/images/glamourpiotr/Glamour(2014.04).jpg',
            alt: 'fot. Piotr Gonia',
            group: 'glamourpiotr'
          },
          {
            src: '/static/images/glamourpiotr/Glamour(2014.07).jpg',
            alt: 'fot. Piotr Gonia',
            group: 'glamourpiotr'
          },
          {
            src: '/static/images/glamourpiotr/Glamour(2014.06).jpg',
            alt: 'fot. Piotr Gonia',
            group: 'glamourpiotr'
          }],
        audrey: [{
          src: '/static/images/audrey/AudreyProject(2015.03.).jpg',
          alt: 'fot. Piotr Gonia',
          group: 'audrey'
        },
          {
            src: '/static/images/audrey/AudreyProject(2015.04).jpg',
            alt: 'fot. Piotr Gonia',
            group: 'audrey'
          },
          {
            src: '/static/images/audrey/AudreyProject(2015)---fot.-Piotr-Gonia.jpg',
            alt: 'fot. Piotr Gonia',
            group: 'audrey'
          },
          {
            src: '/static/images/audrey/AudreyProject(2015.02).jpg',
            alt: 'fot. Piotr Gonia',
            group: 'audrey'
          }],
        womaninred: [{
          src: '/static/images/womaninred/WomanInRed(2015.02).jpg',
          alt: 'fot. Piotr Gonia',
          group: 'womaninred'
        },
          {
            src: '/static/images/womaninred/WomanInRed(2015.03).jpg',
            alt: 'fot. Piotr Gonia',
            group: 'womaninred'
          },
          {
            src: '/static/images/womaninred/WomanInRed(2015.04).jpg',
            alt: 'fot. Piotr Gonia',
            group: 'womaninred'
          },
          {
            src: '/static/images/womaninred/WomanInRed(2015.05).jpg',
            alt: 'fot. Piotr Gonia',
            group: 'womaninred'
          },
          {
            src: '/static/images/womaninred/WomanInRed(2015.06).jpg',
            alt: 'fot. Piotr Gonia',
            group: 'womaninred'
          }],
        referencje: [{
          src: '/static/images/referencje/MikolajWoubishet.jpg',
          alt: 'SM Capitol',
          group: 'referencje'
        },
          {
            src: '/static/images/referencje/JaworzynaTour_referencje.jpg',
            alt: 'Biuro Turystyki Jaworzyna Tour',
            group: 'referencje'
          },
          {
            src: '/static/images/referencje/StowarzyszeniePomocyIskierka.jpg',
            alt: 'Stowarzyszenie Pomocy Iskierka',
            group: 'referencje'
          },
          {
            src: '/static/images/referencje/Sztampa_referencje.jpg',
            alt: 'Teatr Sztampa',
            group: 'referencje'
          },
          {
            src: '/static/images/referencje/TeatrMuzycznyForte.jpg',
            alt: 'Teatr Muzyczny Forte',
            group: 'referencje'
          },
          {
            src: '/static/images/referencje/Camport_referencje.jpg',
            alt: 'Camport Twoja Przystań',
            group: 'referencje'
          }],
        warsztaty: [ { src:  '/static/images/warsztaty/5Warsztaty-teatralne-2013.jpg',
            alt: 'Warsztaty teatralne 2013',
            group: 'warsztaty' },
          { src:  '/static/images/warsztaty/1Warsztaty-teatralne-w-Fundacji-LArche-2018.jpg',
            alt: 'Warsztaty teatralne w Fundacji L\'Arche 2018',
            group: 'warsztaty' },
          { src:  '/static/images/warsztaty/3.Warsztaty-Taneczne-2015.jpg',
            alt: 'Warsztaty Taneczne 2015',
            group: 'warsztaty' },
          { src:  '/static/images/warsztaty/6-Wakacje-Artystyczne-2018-fot.-Bogdan-Sladowski.jpg',
            alt: 'Wakacje Artystyczne 2018 fot. Bogdan Sladowski',
            group: 'warsztaty' },
          { src:  '/static/images/warsztaty/4Warsztaty-teatralne-z-dziecmi-z-ogniska-opiekunczo-wychowawcze.jpg',
            alt: 'Warsztaty teatralne z dziecmi z ogniska opiekunczo wychowawcze',
            group: 'warsztaty' },
          { src:  '/static/images/warsztaty/2jakwyzej.jpg',
            alt: 'Warsztaty teatralne z dziecmi z ogniska opiekunczo wychowawcze',
            group: 'warsztaty' } ],
        warsztatynew:
           [ { src: '/static/images/warsztatynew/stop.jpg',
               alt: 'fot. Krzysztof Wilma',
               group: 'warsztaty-new' },
             { src: '/static/images/warsztatynew/paw-z-rak.jpg',
               alt: 'fot. Krzysztof Wilma',
               group: 'warsztaty-new' },
             { src: '/static/images/warsztatynew/grupa-glowy-na-ramionach.jpg',
               alt: 'fot. Krzysztof Wilma',
               group: 'warsztaty-new' },
             { src: '/static/images/warsztatynew/grupa-siedzi.jpg',
               alt: 'fot. Krzysztof Wilma',
               group: 'warsztaty-new' },
             { src: '/static/images/warsztatynew/uscisk.jpg',
               alt: 'fot. Krzysztof Wilma',
               group: 'warsztatynew' } ],
        musicList: [
          {
            title: 'Jeszcze poczekajmy cover',
            artist: 'Agnieszka Hałka',
            src: '/static/audio/Jeszcze poczekajmy - Agnieszka Hałka (cover).mp3',
            pic: '/static/images/miniaturkidoaudio/jeszcze-poczekajmy.png'
          },
          {
            title: 'Shallow (Lady Gaga) cover',
            artist: 'Agnieszka Hałka',
            src: '/static/audio/Shallow-cover(Agnieszka Halka).mp3',
            pic: '/static/images/miniaturkidoaudio/shallow.jpg'
          },
          {
            title: 'LOVE (Nat King Cole) cover',
            artist: 'Agnieszka Hałka',
            src: '/static/audio/Love-cover(AgnieszkaHalka).mp3',
            pic: '/static/images/miniaturkidoaudio/shallow.jpg'
          },
          {
            title: 'Je t\'aime (L.Fabian) cover',
            artist: 'Agnieszka Hałka',
            src: '/static/audio/Je-taime(L.Fabian)-cover(2015).mp4',
            pic: '/static/images/miniaturkidoaudio/jetaime.jpg'
          },
          {
            title: 'No Habra Nadie En El Mundo (Concha-Buika) cover',
            artist: 'Agnieszka Hałka',
            src: '/static/audio/No-Habra-Nadie-En-El-Mundo(Concha-Buika)-cover(2015).mp3',
            pic: '/static/images/miniaturkidoaudio/habra.jpg'
          },
          {
            title: 'Nie budźcie mnie (K.Jędrusik) cover',
            artist: 'Agnieszka Hałka',
            src: '/static/audio/Nie-budzcie-mnie(K.Jedrusik)-cover(2015).mp4',
            pic: '/static/images/miniaturkidoaudio/niebudzciemnie.jpg'
          },
          {
            title: 'Manio to moje słonko (B.Krafftowna) cover',
            artist: 'Agnieszka Hałka',
            src: '/static/audio/Manio-to-moje-slonko(B.Krafftowna)-cover(2015).mp4',
            pic: '/static/images/miniaturkidoaudio/maniek.jpg'

          }
        ],
        musicTheme: '#874B57'


      };

    },
    methods: {
      track() {
        this.$ga.page({
          page:'/',
          title: 'Home Page',
          location: window.location.href
        });
      },
      playing() {
            console.log('\o/ we are watching!!!')
          },
      openLightbox: function (event) {
        //console.log(event.target);
        if (event.target.children && event.target.children.length > 0) {
          event.target.children[0].click();
        }
      },
      getBackgroundImageStyle(imagesSet, imgNumber) {
        imgNumber = imgNumber || 0;
        return "background-image: url('" + imagesSet[imgNumber].src + "')";
      },
      showMore: function (event) {
        this.isRevealed = !this.isRevealed;
        if (this.isRevealed) {
          this.button.text = "zwiń";
        } else {
          this.button.text = "zobacz więcej";
        }
      }
    },
    mounted() {
      var appjs = require('./assets/js/app.js');
      var plugins = require('./assets/js/plugins.min.js');
      this.track();
    },
    computed: {
      player() {
        return this.$refs.youtube.player
      }
    }
  }

</script>

<style>
  @import './assets/css/app-poncho.css';

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
  }

  *[hidden] {
    display: none;
  }

  .figure:hover {
    opacity: 0.8;
    transition: 200ms ease-in;
    cursor: -moz-zoom-in;
    cursor: -webkit-zoom-in;
    cursor: zoom-in;
  }

  .figure p {
    position: absolute;
    bottom: 0;
    opacity: 0.5;
    font-size: 2rem;
    line-height: 3rem;
    color: black;
    background-color: white;
    width: 100%;
  }

  .flleft {
    width: 20rem;
    height: 20rem;
    float: left;
    margin-right: 10px;
    padding: 0;
  }

  .flright {
    width: 20rem;
    height: 20rem;
    float: right;
    margin-left: 10px;
    padding: 0;
  }

  .fullscreen-v-img {
    background: -webkit-gradient(left bottom, right top, color-stop(0%, #403a3e), color-stop(100%, #be5869)) !important;
    background: linear-gradient(45deg, #403a3e 0%, #be5869 100%) !important;
  }

  .collapsed {
    height: 350px;
    overflow: hidden;
    position: relative;
  }

  .collapsed:after {
    content: "";
    width: 100%;
    height: 80px;
    position: absolute;
    bottom: 0;
    right: 0;
    background: linear-gradient(rgba(255, 255, 255, 0), rgba(242, 242, 242, 1)); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  }

  .revealed {
    height: 100%;
  }

  .revealed.collapsed:after {
    background: none;
  }

  #referencje img {
    vertical-align: top;
    width: 33%;
  }

  @media only screen and (max-width: 640px) {
    .figure p {
      height: 3rem;
      overflow: hidden;
    }
  }

  .aplayer-icon {
    line-height: normal;
    min-width: 0;
  }
  .aplayer-icon:after {
    position: unset;
  }
  .aplayer-icon:hover {
    background: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue